import { useAppSelector, useAppDispatch } from '@/redux/hooks'

// Libs
import { setVideoInput, setIsMicEnabled, setIsCameraEnabled } from '@/redux/reducers/media'

// Constants

type VideoActionType = {
  currentStreamRef: any
  handleCameraClick?: any
  handleMicClick?: any
  role?: any
}

const useVideoAction = (props: VideoActionType) => {
  const { currentStreamRef, handleCameraClick, handleMicClick, role } = props

  const mediaData = useAppSelector((state) => state.media.mediaData)
  const isMicEnabled = useAppSelector((state) => state.media.isMicEnabled)
  const isCameraEnabled = useAppSelector((state) => state.media.isCameraEnabled)

  const dispatch = useAppDispatch()

  const { currentVideoInputIndex, videoDevices } = mediaData

  const isDisabledCameraSwitch = !isCameraEnabled
  const isMultiCamera = videoDevices.length > 1

  const handleMicStatus = () => {
    if (currentStreamRef.current) {
      if (handleMicClick) handleMicClick()

      const audioTrack = currentStreamRef.current.getAudioTracks()[0]
      audioTrack.enabled = !isMicEnabled // 開關麥克風

      dispatch(setIsMicEnabled({ isMicEnabled: !isMicEnabled }))
    }
  }

  const handleCameraStatus = () => {
    if (currentStreamRef.current) {
      if (handleCameraClick) handleCameraClick()

      // Setting videoTrack.enabled to false will not close camera indicator and there will be black frame sending to audience,
      // so we recreate webrtc and set video constraint to true/false instead.
      // const videoTrack = currentStream.getVideoTracks()[0]
      // if (videoTrack) videoTrack.enabled = !isCameraEnabled // 開關鏡頭

      dispatch(setIsCameraEnabled({ isCameraEnabled: !isCameraEnabled }))
    }
  }

  const handleCameraSwitch = () => {
    if (isDisabledCameraSwitch) return

    const videoLength = videoDevices?.length

    if (currentVideoInputIndex >= videoLength - 1) {
      dispatch(setVideoInput({ currentVideoInputIndex: 0 }))
    } else {
      dispatch(setVideoInput({ currentVideoInputIndex: currentVideoInputIndex + 1 }))
    }
  }

  return { isMicEnabled, isCameraEnabled, isDisabledCameraSwitch, isMultiCamera, handleMicStatus, handleCameraStatus, handleCameraSwitch, role }
}

export default useVideoAction
